export default {"src":"/_next/static/media/NWL.20b3a502.svg","height":18,"width":18};